<template>
    <div class="main">
        <my_menu active_name="2-0" :open_active="['2']"></my_menu>

        <div class="content">
            <div>
                <Tabs v-model="tab_index">
                    <TabPane v-for="(item, i) in label_data" :key="i" :label="item.label" :name="item.label">
                        <div class="options_div">
                            <Button type="primary" size="small" style="font-size:10px" @click="click_tab(item)">
                                <Icon type="md-add" /> 添加IP
                            </Button>
                        </div>
                        <div>
                            <Table size="small" :columns="columns" :data="item.data">

                                <template #action="{ row }">
                                    <a class="delip" @click="click_del(row)"> 删除</a>
                                </template>

                            </Table>
                        </div>

                    </TabPane>
                </Tabs>
            </div>

        </div>


        <Modal width="420" v-model="add_ip_show" title="添加权限" :footer-hide="true">
            <div class="add_ip_div">
                <div class="add_ip_field">IP：</div>
                
                <Input v-model="ip" placeholder="请输入ip" style="width: 250px" />
            </div>
            <div class="add_ip_div">
                <div class="add_ip_field">备注：</div>
                <Input v-model="remarks" placeholder="请输入备注" style="width: 250px" />
            </div>
            <div class="add_button_div">
                <Button type="primary" style="font-size:10px" @click="add_ip">
                    <Icon type="md-add" /> 确认添加
                </Button>

            </div>
        </Modal>

    </div>


</template>

<script>
import my_menu from '@/component/admin/menu/menu.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            label_data: [],
            tab_index: '',
            columns: [],
            data: [],

            current_item: {},

            remarks: '',
            ip: '',

            add_ip_show: false



        }
    },

    mounted() {
        this.window_change()
        this.get_ip_data()
    },

    methods: {

        click_tab(e) {
            this.current_item = e
            this.add_ip_show = true
        },


        click_del(item) {
            var that = this
            this.$Modal.confirm({
                title: '删除IP',
                content: '正在删除，是否继续？',
                onOk: () => {
                    that.del_ip(item)
                },
                onCancel: () => {

                }
            })
        },

        //获取ip数据
        get_ip_data() {
            console.log('获取ip数据')
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/ak/white_ip/list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.label_data = res.data.ip_data
                        that.current_item = that.label_data[0]
                        that.columns = res.data.columns


                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


        //添加ip
        add_ip() {
            if (this.ip == '') {
                this.$Message.error('请输入ip')
                return
            }

            var that = this
            var obj = {
                sys_type: this.current_item.value,
                ip: this.ip,
                remarks: this.remarks
            }
            http("post", process.env.VUE_APP_HOST + "/ak/white_ip/add_ip", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.add_ip_show = false
                        that.get_ip_data()

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


        //删除ip
        del_ip(item) {


            var that = this
            var obj = {
                sys_type: this.current_item.value,
                ip: item.ip
            }
            http("post", process.env.VUE_APP_HOST + "/ak/white_ip/del_ip", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });

                        that.get_ip_data()

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.add_ip_div{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.add_ip_field{
    width:100px;
}

.delip {
    color: #fb2600ea;
    cursor: pointer;
}

.add_button_div {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.options_div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.card_main {}

.card_field {
    width: 100px;
    flex-shrink: 0;
}

.card_line {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

}

.color {
    color: #0bbb05
}

.card {
    padding: 10px;
    border-bottom: 1px solid rgb(242, 242, 242)
}

.div_options {
    display: flex;
    justify-content: flex-end;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    overflow: auto;
    padding: 10px;
    width: calc(100% - 220px);
    background-color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
    height: calc(100vh - 20px);
    border-radius: 5px;
}

.main {
    background: #ececec;
    min-height: 100vh;
}
</style>